var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0997 2.39938C21.3274 2.62704 21.4069 2.96378 21.3051 3.26922L15.3048 21.2692C15.1961 21.5954 14.9016 21.8239 14.5587 21.8483C14.2158 21.8726 13.8919 21.688 13.7382 21.3805L9.8649 13.634L2.11832 9.76068C1.81082 9.60693 1.62621 9.28308 1.65059 8.94016C1.67496 8.59723 1.90351 8.30275 2.22966 8.19403L20.2299 2.19403C20.5353 2.09222 20.8721 2.17172 21.0997 2.39938ZM11.5327 13.1683L14.341 18.7849L19.1547 4.34438L4.71403 9.15788L10.3306 11.9662L13.3976 8.89939C13.7296 8.56745 14.2677 8.56747 14.5997 8.89943C14.9316 9.23138 14.9316 9.76957 14.5996 10.1015L11.5327 13.1683Z",
    fill: "#2E1834"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.11085c09c949b9dcb813cb547ba26e86.svg";
export { ForwardRef as ReactComponent };